export const getBaseUrl = () => {
  return process.env.REACT_APP_ENV === 'development' &&
    !process.env.REACT_APP_BACKEND_URL?.includes('localhost')
    ? 'http://localhost:5000'
    : process.env.REACT_APP_BACKEND_URL;
};
